/**
 * Created by Daniela on 23/01/2017.
 */
export const apiName: string = 'tanques';
export const tanquesRoute: string = 'tanques';
export const tanquesStorage: string = 'tanques';
export const tanquesModuleName: any = {plural: 'Tanques', single: 'Tanque'};

export const tanquesEstoqueRoute: string = 'estoque';
export const tanquesEstoqueModuleName: any = {plural: 'Estoques', single: 'Estoque'};

export const tanquesMovimentacaoApiName: string = 'movimentacoes-tanques';
export const tanquesMovimentacaoAreaApiName: string = 'areas-movimentacoes-tanques';
export const tanquesMovimentacaoRoute: string = 'movimentacao';
export const tanquesMovimentacaoModuleName: any = {plural: 'Movimentações', single: 'Movimentação'};

export const tanquesQuery = {
    "where":{
        "ativo":true,
        "identificacao":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"identificacao",
    "include": ["combustivel"]
};

export const TiposMovimentacoesTanques: any[]  = [
    {Key: 1, Value: "Entrada"},
    {Key: 2, Value: "Saída"},
    {Key: 3, Value: "Estorno"},
    {Key: 4, Value: "Ajuste"},
    {Key: 5, Value: "Tranferência"}
]


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/shared/data.service.ts
 **/